<template>
    <form-dialog
        ref="form_login_alter_password"
        title="修改密码"
        :data="LoginAlterPasswordDialog.data"
        :visible.sync="visibleSync"
        :columns="LoginAlterPasswordDialog.columns"
        @confirm="SavePassword"
    ></form-dialog>
</template>
<script>
export default {
    name: `LoginAlterPassword`,
    props: {
        visible: { type: Boolean, default: () => false },
        userid: { type: Number, default: () => 0 },
        username: { type: String }
    },
    data() {
        let validatePass = (rule, value, callback) => {
            if (value === ``) {
                callback(new Error(`请输入密码`))
            } else {
                if (this.LoginAlterPasswordDialog.data.newpassword2 !== ``) {
                    this.$refs.form_login_alter_password.validateField(`newpassword2`)
                }
                callback()
            }
        }
        let validatePass2 = (rule, value, callback) => {
        // console.log(this.$refs.form_login_alter_password.$refs.form.formdata)
            if (value === ``) {
                callback(new Error(`请再次输入密码`))
            } else if (value !== this.$refs.form_login_alter_password.$refs.form.formdata.newpassword) {
                callback(new Error(`两次输入密码不一致!`))
            } else {
                callback()
            }
        }
        return {
            title: `修改密码`,
            passwordMode: this.$root.PasswordMode,
            passwordMaxErrorCount: this.$root.PasswordMaxErrorCount,
            passwordExpiredRemindDays: this.$root.PasswordExpiredRemindDays,
            passwordRegularExpression: this.$root.PasswordRegularExpression,
            passwordRegularTipMsg: this.$root.PasswordRegularTipMsg,
            LoginAlterPasswordDialog: {
                title: `修改密码`,
                data: { username: ``, newpassword: ``, newpassword2: ``, oldpassword: `` },
                columns: [
                    {
                        type: `string`,
                        prop: `username`,
                        label: `用户名`,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        colspan: 24
                    }, {
                        type: `string`,
                        prop: `oldpassword`,
                        label: `原密码`,
                        // options: [],
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        colspan: 24
                    }, {
                        type: `string`,
                        prop: `newpassword`,
                        label: `新密码`,
                        // options: [],
                        validate: [{ validator: validatePass, trigger: `blur` }, { required: true, message: `必填项目`, trigger: `blur` }],
                        colspan: 24
                    }, {
                        type: `string`,
                        prop: `newpassword2`,
                        label: `再输一次`,
                        // options: [],
                        validate: [{ validator: validatePass2, trigger: `blur` }, { required: true, message: `必填项目`, trigger: `blur` }],
                        colspan: 24
                    }]
            }
        }
    },
    computed: {
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.LoginAlterPasswordDialog.data = { username: this.username, newpassword: ``, newpassword2: ``, oldpassword: `` }
                this.$emit(`update:visible`, newval)
            }
        }
    },
    mounted() {
    },
    methods: {
        SavePassword($data) {
            let that = this
            let data = {
                username: $data.username,
                password: $data.newpassword2,
                old_password: $data.oldpassword
            }
            let patten = /\s/
            if (patten.test(data.password)) {
                this.$message.error(`密码中不能含有空格`)
                return
            }
            // 如果启用正则验证，校验正则
            if (this.passwordMode == `1`) {
                if (!data.password.match(this.passwordRegularExpression)) {
                    this.$message.error(this.passwordRegularTipMsg)
                    return
                }
            }
            // let { newpassword2: data.password, oldpassword: data.old_password } = this.LoginAlterPasswordDialog.data
            this.myaxios.post(`api/AcisSystem/Authorization/ChangeLoginPassword`, data)
                .then((response) => {
                    this.$message.success(`修改成功`)
                    that.visibleSync = false
                }, (res) => {
                    console.log(res)
                })
        }
    },
    watch: {
        username(newVal) {
            this.$set(this.LoginAlterPasswordDialog.data, `username`, newVal)
        }
    }
}</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/LoginAlterPassword.vue